import { AnimatePresence } from 'framer-motion';
import {
	Buzz,
	Counter,
	SideDrawer,
	Tabs,
	Tab,
} from '@aleph/shared-components';
import useNotificationsPolling
	from 'wb-reddit/app/routes/superGrid/actionRow/notifications/hooks/useNotificationsPolling';
import useSnackbarNotifications
	from 'wb-reddit/app/routes/superGrid/actionRow/notifications/hooks/useSnackbarNotifications';
import UnreadNotifications from 'wb-reddit/app/routes/superGrid/actionRow/notifications/components/unread';
import ArchivedNotifications from 'wb-reddit/app/routes/superGrid/actionRow/notifications/components/archived';
import ReadAllNotifsButton from 'wb-reddit/app/routes/superGrid/actionRow/notifications/components/readAll';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type RedditNotificationsOverlayParams = {
	open: boolean
	onClose: () => void
};

const RedditNotificationsOverlay = ({
	open,
	onClose,
}: RedditNotificationsOverlayParams) => {
	const { t } = useTranslation();

	const {
		notifications,
	} = useNotificationsPolling();

	useSnackbarNotifications();

	const notificationCount = notifications.length;

	const notificationItems = useMemo(() => [
		{
			title:   'Unread',
			content: <UnreadNotifications onClose={onClose}/>,
		},
		{
			title:   'Archived',
			content: <ArchivedNotifications onClose={onClose} />,
		},
	] satisfies Tab[], []);

	return (
		<AnimatePresence>
			{
				open
				&& <SideDrawer
					onClose={onClose}
					className="h-full bg-white w-[640px] shadow-md"
					classNameBackdrop="backdrop-blur-[7.5px] bg-white/[.01]"
					classNameContent="pl-4 pr-4"
					header={
						<div className="text-[18px] font-medium flex gap-[16px]">
							<div className="relative">
								<Buzz
									width={24}
									height={24}
								/>

								<Counter
									count={notificationCount}
									className='top-[-6px] right-[-6px]'
									variant="square-accent"
								/>
							</div>

							<div>{t('sc.notification.label', 'Notifications')}</div>
						</div>
					}
				>
					<Tabs
						tabs={notificationItems}
						className="!px-0 pt-[6.5px]"
						triggersRenderer={(triggers, activeTab) => (
							<div className="flex justify-between items-center w-full">
								<div>
									{triggers}
								</div>
								{
									activeTab?.index === 0 && <ReadAllNotifsButton />
								}
							</div>
						)}
					/>
				</SideDrawer>
			}
		</AnimatePresence>
	);
};

export default RedditNotificationsOverlay;
